module.exports = [{
      plugin: require('/Users/shepko/gatsby_stefunga/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
